import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import {  acceptMemberInvitationApi, addMemberApi, getAllOrganisationsApi, removeMemberApi, resendMemberInvitationApi, updateMemberRoleApi,  viewMembersApi } from "../../services/api";
import { setGuestReviewState } from "../../redux/guestSlice";
import { setTheme } from "../../redux/customThemeSlice";
import { getTheme } from "../whitelabel/actions";
import { getPermissions } from "../../commonactions/actions";
import { updateState } from "../../redux/commonSlice";
import { updateProjectState } from "../../redux/projectSlice";
import { setSnackbar } from "../../redux/messageSlice";
import useOrganisationProjectActions from "../events/useOrganisationProjectActions";
import { updatePendingCallState } from "../../redux/pendingCallSlice";
import { updateTeamState } from "../../redux/teamSlice";



export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const {getOrganisationProjectsList} = useOrganisationProjectActions()
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
 

 ////////////////////GET get organisations list api    api/v1/organisations//////////////////////////

    const getOrganisationsList = ( callback ) => {
      dispatch(updateState({is_organisation_list_loading: true}))
      getAllOrganisationsApi() 
      .then((response) => {
       dispatch(updateState({is_organisation_list_loading: false}))
        if(response?.data?.http_code === 200){
          // const firstValidElement = response.data.data.org_details.filter(item => item.name !== null && item.name !== '').at(0);
          dispatch(updateState({organisation_list: response.data?.data?.org_details}))

         // getOrganisationProjectsList({organisation_id : firstValidElement?.id})
        //  console.log(response.data.data.org_details)
         callback && callback()
        
       }
      })
      .catch((error) => {
       if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      }
      });
    }


   ////////////////////GET get user management members list api   api/v1/user_managements/view_members//////////////////////////

    const getOrganisationMembersList = ( callback ) => {
        dispatch(updateState({is_loading: true}))
        viewMembersApi() 
        .then((response) => {
         dispatch(updateState({is_loading: false}))
          if(response?.data?.http_code === 200){
           dispatch(updateState({organisation_members_list: response.data.data.user_details}))
          //  console.log(response.data.data.user_details)
           callback && callback()
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
        }
        });
      }

  ////////////////////POST add organisation member api   api/v1/user_managements/add_member//////////////////////////

    const addOrganisationMember = (values ,callback ) => {
        // dispatch(updateState({is_loading: true}))
          const payload = values   
      addMemberApi(payload) 
        .then((response) => {
          // console.log({response})
          dispatch(updateState({is_loading: false}))
          if(response?.data?.http_code === 200){
            getOrganisationMembersList()
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            !!callback && callback()
          }
        })
        .catch((error) => {
            if(error) {
                const errorObject = error?.response?.data;
                showSnackBar(dispatch, errorObject);
              }
        //   dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
        });
      }


    //////////////////PUT update organisation member role api api/v1/user_managements/update_role //////////////////////

   const updateOrganisationMemberRole = (values ,callback, setSelectedRole, role ) => {
    dispatch(updatePendingCallState({changeMemberRole:true}))  
    const payload = values
  updateMemberRoleApi(payload) 
    .then((response) => {
      // console.log({response})
      // dispatch(updateState({is_loading:false})) 
       dispatch(updatePendingCallState({changeMemberRole:false}))   
      dispatch(updateState({change_member_role_confirmation_popup : false, invite_org_members_popup: true}))
      if(response?.data?.http_code === 200){
        //   setSelectedRole(role?.name)
          getOrganisationMembersList()
          dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
          !!callback && callback()
      }
    })
    .catch((error) => {
      dispatch(updateState({is_loading:false}))  
      dispatch(updatePendingCallState({changeMemberRole:false}))   
      dispatch(updateState({change_member_role_confirmation_popup : false, invite_org_members_popup: true}))
      if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      }
    //   dispatch(setSnackbar({type:'error', flag:true, message: error?.response?.data?.message}))
    });
  }
  

/////////////////////DELETE remove organisation member api api/v1/user_managements/remove_member?id=4 ///////////////

 const removeOrganisationMember = (payload ,callback) => {
   
    // dispatch(updateState({is_loading:true})) 
    dispatch(updatePendingCallState({removeMember: true}))
  removeMemberApi(payload) 
  .then((response) => {
    // console.log({response})
    // dispatch(updateState({is_loading:false})) 
    dispatch(updatePendingCallState({removeMember: false}))
    dispatch(updateTeamState({remove_member_confirmation_popup : false}))
    dispatch(updateState({invite_org_members_popup: true}))
    if(response?.data?.http_code === 200){
        getOrganisationMembersList()
        dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
        !!callback && callback()
    }
  })
  .catch((error) => {
    dispatch(updatePendingCallState({removeMember: false}))
    dispatch(updateTeamState({remove_member_confirmation_popup : false}))
    dispatch(updateState({invite_org_members_popup: true}))
    if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
    }
    // dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
  });
}


 ////////////////////POST accept member invitation api api/v1/user_managements/accept_invitation//////////////////////////

 const acceptMemberInvitation = (values ,callback ) => {
    dispatch(updateState({is_loading: true}))
      const payload = values   
  
  acceptMemberInvitationApi(payload) 
    .then((response) => {
      // console.log({response})
      dispatch(updateState({is_loading: false}))
      if(response?.data?.http_code === 200){
        dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
        !!callback && callback()
      }
    })
    .catch((error) => {
        if(error) {
            const errorObject = error?.response?.data;
            showSnackBar(dispatch, errorObject);
          }
    //   dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
    });
  }

   ////////////////////GET resend member invitation api api/v1/user_managements/resend_invitation?id=3//////////////////////////

   const resendMemberInvitation = (payload, callback ) => {
    dispatch(updateState({is_loading: true}))
    resendMemberInvitationApi(payload) 
    .then((response) => {
     dispatch(updateState({is_loading: false}))
      if(response?.data?.http_code === 200){
      //  console.log(response.data.data.user_details)
       callback && callback()
      
     }
    })
    .catch((error) => {
     if(error) {
      const errorObject = error?.response?.data;
      showSnackBar(dispatch, errorObject);
    }
    });
  }
     


    

  return {  getOrganisationsList, getOrganisationMembersList, addOrganisationMember, updateOrganisationMemberRole, removeOrganisationMember, acceptMemberInvitation, resendMemberInvitation};
}